import AcessoApp from 'ajuda-inicializacao';
import { ROT_SET_ROTAS_MENUS_SUCCESS } from '../actions/types';

const INITIAL_STATE = {
  rotas: [
    {
      path: '/acesso-app',
      exact: true,
      component: AcessoApp,
      permitido: true,
    },
  ],
  menus: [],
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case ROT_SET_ROTAS_MENUS_SUCCESS:
      return { ...state, rotas: payload.rotas, menus: payload.menus };
    default:
      return state;
  }
};
